/**
 * URL-hash keys for the box-types feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const BOX_TYPES_HASH = {
  /** `#create` — BoxTypeFormDialog in create mode. */
  create: 'create',
  /** `#edit/<id>` — BoxTypeFormDialog editing a specific box type. */
  edit: 'edit',
  /** `#delete/<id>` — single box-type delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type BoxTypesHashKey =
  (typeof BOX_TYPES_HASH)[keyof typeof BOX_TYPES_HASH];
